import $ from "jquery";
import Cookies from "js-cookie";

function init(): void {
  const $complianceBtn = $(".js-compliance-reject");
  if ($complianceBtn.length) {
    $complianceBtn.click(() => {
      // Please note uk is hardcoded here, if uk region is changed in the CMS this will stop working.
      Cookies.set("Region", "uk", {
        expires: 365,
        path: "/",
        secure: true,
      });
      window.open("/", "_top");
    });
  }
}

export default { init };
